import React from 'react';
import clsx from 'clsx';
import Icon from 'src/images/spiner_icon.svg';
import { useStyles } from '../styles';

export const Spiner = ({ fixed }: ISpinerProps) => {
  const classes = useStyles();
  return (
    <div
      className={clsx(
        classes.wrapper,
        fixed ? classes.fixed : classes.relative
      )}
      data-test-id={'Spiner'}>
      <div className={classes.loader}>
        <Icon />
      </div>
    </div>
  );
};

interface ISpinerProps {
  fixed?: boolean;
}
